import Icon from "../../../components/AppIcon";
import AppImage from "../../../components/AppImage";

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    services: [
      { name: "Empréstimo Consignado", href: "#servicos" },
      { name: "Antecipação FGTS", href: "#servicos" },
      { name: "Renegociação de Dívidas", href: "#servicos" },
      { name: "Consultoria Financeira", href: "#servicos" },
      { name: "Empréstimo para CLT", href: "#servicos" },
    ],
    company: [
      { name: "Sobre Nós", href: "#sobre" },
      { name: "Como Funciona", href: "#como-funciona" },
      { name: "Depoimentos", href: "#depoimentos" },
      { name: "Contato", href: "#contato" },
    ],
    legal: [
      {
        name: "Política de Privacidade",
        href: "/assets/docs/Política de Privacidade TJEP.pdf",
      },
      { name: "Termos de Uso", href: "/assets/docs/Termos de uso TJEP.pdf" },
      { name: "LGPD", href: "/assets/docs/LGPD TJEP.pdf" },
    ],
  };

  const socialLinks = [
    { name: "Facebook", icon: "Facebook", href: "#" },
    {
      name: "Instagram",
      icon: "Instagram",
      href: "https://www.instagram.com/tjep.solucoes?igsh=Zzk3NWJsc3o1NWxi",
    },
    { name: "LinkedIn", icon: "Linkedin", href: "#" },
    { name: "YouTube", icon: "Youtube", href: "#" },
  ];

  const handleLinkClick = (href: string) => {
    if (href?.startsWith("#")) {
      const element = document.querySelector(href);
      if (element) {
        element?.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(
      "Olá! Gostaria de mais informações sobre os serviços da TJEP.",
    );
    window.open(`https://wa.me/553397070278?text=${message}`, "_blank");
  };

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1 space-y-6">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
                <AppImage
                  src="assets/images/LOGO_ISOLADA_WHITE.png"
                  alt="TJEP Soluções Financeiras Logo"
                  className="w-6 h-6"
                />
              </div>
              <div>
                <h3 className="text-xl font-bold">TJEP</h3>
                <p className="text-sm text-gray-400">Soluções Financeiras</p>
              </div>
            </div>

            <p className="text-gray-300 leading-relaxed">
              Soluções financeiras transparentes e éticas para aposentados,
              pensionistas e trabalhadores CLT. Mais de 15.000 clientes
              atendidos em todo o Brasil.
            </p>

            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Icon name="MapPin" size={16} className="text-primary" />
                <span className="text-sm text-gray-300">
                  Rua Antônio Cimini, 130, Sala 503 - Caratinga/MG
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <Icon name="Phone" size={16} className="text-primary" />
                <span className="text-sm text-gray-300">(33) 99707-0278</span>
              </div>
              <div className="flex items-center space-x-3">
                <Icon name="Mail" size={16} className="text-primary" />
                <span className="text-sm text-gray-300">
                  tjepfinanceira@gmail.com
                </span>
              </div>
            </div>
          </div>

          {/* Services Links */}
          <div className="space-y-6">
            <h4 className="text-lg font-semibold">Nossos Serviços</h4>
            <ul className="space-y-3">
              {footerLinks?.services?.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => handleLinkClick(link?.href)}
                    className="text-gray-300 hover:text-primary transition-colors duration-200 text-sm"
                  >
                    {link?.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div className="space-y-6">
            <h4 className="text-lg font-semibold">Empresa</h4>
            <ul className="space-y-3">
              {footerLinks?.company?.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => handleLinkClick(link?.href)}
                    className="text-gray-300 hover:text-primary transition-colors duration-200 text-sm"
                  >
                    {link?.name}
                  </button>
                </li>
              ))}
            </ul>

            <div className="pt-4">
              <h5 className="text-sm font-semibold mb-3">Redes Sociais</h5>
              <div className="flex space-x-3">
                {socialLinks?.map((social, index) => (
                  <a
                    key={index}
                    href={social?.href}
                    className="w-8 h-8 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-primary transition-colors duration-200"
                    title={social?.name}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Icon name={social?.icon as any} size={16} />
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Legal & Contact */}
          <div className="space-y-6">
            <h4 className="text-lg font-semibold">Legal</h4>
            <ul className="space-y-3">
              {footerLinks?.legal?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.href}
                    className="text-gray-300 hover:text-primary transition-colors duration-200 text-sm"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {link?.name}
                  </a>
                </li>
              ))}
            </ul>

            <div className="pt-4">
              <button
                onClick={handleWhatsAppClick}
                className="w-full bg-green-600 hover:bg-green-700 text-white px-4 py-3 rounded-lg flex items-center justify-center space-x-2 transition-colors duration-200"
              >
                <Icon name="MessageCircle" size={16} />
                <span className="text-sm font-medium">Fale Conosco</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Trust Indicators */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex items-center space-x-3">
              <Icon name="Shield" size={20} className="text-primary" />
              <div>
                <p className="text-sm font-medium">CNPJ Ativo</p>
                <p className="text-xs text-gray-400">63.284.659/0001-37</p>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <Icon name="Building" size={20} className="text-primary" />
              <div>
                <p className="text-sm font-medium">Banco Central</p>
                <p className="text-xs text-gray-400">Autorização Oficial</p>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <Icon name="Lock" size={20} className="text-primary" />
              <div>
                <p className="text-sm font-medium">Dados Protegidos</p>
                <p className="text-xs text-gray-400">LGPD Compliance</p>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <Icon name="Award" size={20} className="text-primary" />
              <div>
                <p className="text-sm font-medium">ISO 27001</p>
                <p className="text-xs text-gray-400">Segurança Certificada</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-400">
              © {currentYear} TJEP Soluções Financeiras. Todos os direitos
              reservados.
            </div>
          </div>
        </div>
      </div>
      {/* Disclaimer */}
      <div className="bg-gray-950 border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <p className="text-xs text-gray-500 text-center leading-relaxed">
            TJEP Soluções Financeiras é uma empresa de consultoria financeira
            devidamente registrada. Todas as operações são realizadas em
            parceria com instituições financeiras autorizadas pelo Banco Central
            do Brasil. As taxas e condições podem variar conforme análise de
            crédito. Consulte sempre as condições específicas antes de contratar
            qualquer produto financeiro.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
